const hasNegativeItemFeedback = (feedback) =>
  feedback === 'Negative' ||
  feedback?.feedback === 'Negative' ||
  feedback?.ratingScored === 'Negative';

export default hasNegativeItemFeedback;
